<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :details="details"/>
      </div>
    </div>

    <Items class="block" :access="access" :items="details.Items"/>

    <template v-if="access.Glob_HPP">
      <Total class="block" :details="details"/>
    </template>
  </kst-page-print-details>
</template>

<script>
import Model from "../StopModel.js";
import Services from "../../../services/Api/StockOpnameServices.js";

import Details from "./StopPD_Details.vue";
import Items from "./StopPD_Items.vue";
import Total from "./StopPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Details,
    Items,
    Total,
    Company
  },
  data: () => ({
    access: {},
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.details = data.Details;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>